import { useEffect, useState } from "react";

export type Theme = "system" | "light" | "dark";
export interface Settings { theme: Theme; reducedMotion: boolean; shortcuts: boolean }

const KEY = "lawsim.settings";
const DEFAULTS: Settings = { theme: "system", reducedMotion: false, shortcuts: true };

function load(): Settings {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? { ...DEFAULTS, ...(JSON.parse(raw) as Partial<Settings>) } : DEFAULTS;
  } catch {
    return DEFAULTS;
  }
}

/** Per-viewer conveniences only; nothing here touches the simulation. */
export function useSettings(): [Settings, (s: Partial<Settings>) => void] {
  const [settings, setSettings] = useState<Settings>(load);
  useEffect(() => {
    const root = document.documentElement;
    if (settings.theme === "system") delete root.dataset.theme;
    else root.dataset.theme = settings.theme;
    if (settings.reducedMotion) root.dataset.motion = "reduced";
    else delete root.dataset.motion;
    try {
      localStorage.setItem(KEY, JSON.stringify(settings));
    } catch {
      // storage unavailable (private window); settings still apply for this session
    }
  }, [settings]);
  return [settings, (s) => setSettings((prev) => ({ ...prev, ...s }))];
}
